module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "ma-0"
  }, [_c('a', {
    attrs: {
      "name": "top",
      "id": "top"
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.response.loading) ? _c('v-progress-circular', {
    attrs: {
      "width": "2",
      "color": "amber",
      "indeterminate": ""
    }
  }) : _c('v-icon', [_vm._v("send")]), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "hidden-xs-only"
  }, [_vm._v("\n      Messages\n    ")]), _vm._v(" "), (_vm.totalResults) ? _c('span', {
    staticClass: "ml-2 pt-1 hidden-xs-only"
  }, [_vm._v("\n      Showing " + _vm._s(_vm.messages.length) + " of " + _vm._s(_vm.totalResults) + " messages\n    ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "search",
      "hint": "press enter to search",
      "clearable": "",
      "append-icon": "search"
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.dosearch.apply(null, arguments)
      },
      "click:append": _vm.dosearch,
      "click:clear": function($event) {
        return _vm.dosearch(10)
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-switch', {
    staticClass: "pl-3 ml-3 mr-3 mt-3",
    staticStyle: {
      "flex": "none"
    },
    attrs: {
      "label": "Only failed"
    },
    model: {
      value: (_vm.failed),
      callback: function($$v) {
        _vm.failed = $$v
      },
      expression: "failed"
    }
  }), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.fetch
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1)], 1), _vm._v(" "), (_vm.response.loading) ? _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "height": "2",
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "background-color": "gray lighten-4"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', [_vm._v(_vm._s(_vm.$t('tabs.inbox')))]), _vm._v(" "), (_vm.$store.getters.isAdmin) ? _c('v-tab', [_vm._v(_vm._s(_vm.$t('tabs.communicationtemplates')))]) : _vm._e(), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-tab-item', [_c('inbox', {
    attrs: {
      "messages": _vm.messages
    },
    on: {
      "selected": _vm.setSelected
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-pagination', {
    staticClass: "my-2 mr-4",
    attrs: {
      "circle": "",
      "length": _vm.numPages,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": function($event) {
        return _vm.$vuetify.goTo("#top")
      }
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1), _vm._v(" "), (_vm.numPages > 1) ? _c('v-footer', {
    staticClass: "text-xs-center"
  }, [_c('v-icon', {
    staticClass: "ml-2 mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v(" "), _c('small', [_vm._v("Notification data is only available for more recent notifications")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.response.loading) ? _c('v-progress-circular', {
    attrs: {
      "width": "2",
      "color": "amber",
      "indeterminate": ""
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.response.loading && _vm.messages.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("\n            No messages found\n          ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-tab-item', [_c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.templatePage),
      callback: function($$v) {
        _vm.templatePage = $$v
      },
      expression: "templatePage"
    }
  }, [_c('v-window-item', [_c('communication-template-list', {
    attrs: {
      "title": _vm.$t("comms.title")
    },
    on: {
      "selected": _vm.setSelectedCommunicationTemplate,
      "new": function($event) {
        return _vm.setSelectedCommunicationTemplate(null)
      }
    }
  })], 1), _vm._v(" "), _c('v-window-item', [_c('communication-template-form', {
    attrs: {
      "context-type": "Appointment"
    },
    on: {
      "close": function($event) {
        _vm.templatePage = 0
      }
    },
    model: {
      value: (_vm.selectedTemplate),
      callback: function($$v) {
        _vm.selectedTemplate = $$v
      },
      expression: "selectedTemplate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "600"
    },
    model: {
      value: (_vm.showCompose),
      callback: function($$v) {
        _vm.showCompose = $$v
      },
      expression: "showCompose"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 overline grey lighten-4"
  }, [_vm._v("\n          Compose message\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showCompose = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('compose')], 1)], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticStyle: {
      "z-index": "11"
    },
    attrs: {
      "persistent": "",
      "right": "",
      "fixed": "",
      "hide-overlay": "",
      "width": "400"
    },
    model: {
      value: (_vm.showDetail),
      callback: function($$v) {
        _vm.showDetail = $$v
      },
      expression: "showDetail"
    }
  }, [_c('v-system-bar', {
    staticClass: "visible-ios-only main",
    attrs: {
      "status": "",
      "dark": ""
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "flat": "",
      "dark": "",
      "dense": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.selected = null;
        _vm.showDetail = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.selected) ? _c('communication-card', {
    attrs: {
      "id": _vm.selected.id,
      "initial-data": _vm.selected,
      "fetch": true
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5698c06a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/communications/index.vue
// module id = 1429
// module chunks = 9